import {post,get} from '../../libs/ajax.js'

export default {
    // 获取操作人
    getUserList: (data, options) => {
        return get('/mp_sys_operation_log/get_user_list', data, options)
    },
    // 获取模块
    getModule: (data, options) => {
        return get('/mp_sys_operation_log/get_module', data, options)
    },
    // 获取操作类型
    getLogType: (data, options) => {
        return get('/mp_sys_operation_log/get_log_type', data, options)
    },
    // 获取操作账户列表
    getLogAccountList: (data, options) => {
        return get('/mp_sys_operation_log/get_account_list ', data, options)
    },
    // 获取系统日志列表
    getDataList: (data, options) => {
        return get('/mp_sys_operation_log/get_list', data, options)
    },
}
